import { apiSlice } from 'store/slices/api/api-slice';
import {
    CategoryEditResponse,
    CategoryListResponse,
    CreateCategoryRequest,
    EditCategoryRequest,
} from 'types/toont-tint/toon-tint';
import {
    ProductTitleListRequest,
    ProductTitleListResponse,
} from 'types/product/product';

export const toonTinCategorytApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        saveToonTintCategory: builder.mutation<string, CreateCategoryRequest>({
            query: (toonTintItemRequest: CreateCategoryRequest) => ({
                url: `toon-tint/category-save`,
                method: 'POST',
                body: toonTintItemRequest,
            }),
        }),

        editCategoryToonTint: builder.mutation<void, EditCategoryRequest>({
            query: (editCategoryRequest: EditCategoryRequest) => ({
                url: `/toon-tint/category-update/${editCategoryRequest.categoryId}`,
                method: 'PUT',
                body: { ...editCategoryRequest },
            }),
        }),

        categoryList: builder.query<CategoryListResponse, string>({
            query: (cardId: string) => ({
                url: '/toon-tint/category-list/' + cardId,
                method: 'GET',
            }),
        }),

        getCategoryIdData: builder.query<CategoryEditResponse, string>({
            query: (params: string) => ({
                url: `toon-tint/category/${params}`,
                method: 'GET',
            }),
        }),

        productTitleSearchList: builder.query<
            ProductTitleListResponse[],
            ProductTitleListRequest
        >({
            query: (params: ProductTitleListRequest) => ({
                url: `/product/product-title-list`,
                method: 'GET',
                params: params,
            }),
        }),
    }),
});

export const {
    useSaveToonTintCategoryMutation,
    useEditCategoryToonTintMutation,
    useCategoryListQuery,
    useGetCategoryIdDataQuery,
    useProductTitleSearchListQuery,
} = toonTinCategorytApi;
